/* unplugin-vue-components disabled */import { render } from "./industrial-model-item.vue?vue&type=template&id=7f9ad5bc&scoped=true"
import script from "./industrial-model-item.vue?vue&type=script&lang=js"
export * from "./industrial-model-item.vue?vue&type=script&lang=js"

import "./industrial-model-item.vue?vue&type=style&index=0&id=7f9ad5bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f9ad5bc"]])

export default __exports__